<template>
  <div class="sld_order_list">
    <MemberTitle memberTitle="询价详情"></MemberTitle>
    <div class="warp1">
      <div class="dital1">询价详情</div>
      <!-- <div class="dital">询价详情</div> -->
      <div class="center">
        <div class="center_box" style="width: 330px">
          <div style="width: 140px; padding-left: 17px">报价截止时间：</div>
          <el-date-picker
            v-model="deadlineTime"
            class="opop1"
            type="date"
            placeholder="无"
            readonly
          ></el-date-picker>
          <span class="cored1">*</span>
        </div>
        <div class="center_box" style="width: 320px">
          <div class="yy" style="width: 100px">交货时间:</div>
          <el-date-picker
            v-model="input"
            class="opop"
            type="date"
            placeholder="无"
            readonly
          ></el-date-picker>
        </div>
        <div class="center_box">
          <div class="yy">品名：</div>
          <el-input
            v-model="inquiryGoodsName"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
        </div>
        <div class="center_box">
          <div class="yy">规格：</div>
          <el-input
            v-model="inquirySpec"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
        </div>
        <div class="center_box">
          <div class="yy">单位目标价：</div>
          <el-input
            v-model="targetPrice"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
        </div>
        <div class="center_box">
          <div class="yy">采购量：</div>
          <el-input
            v-model="purchaseNumber"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
        </div>
      </div>
      <div class="textarea1">
        <div class="trt">描述:</div>
        <el-input
          type="textarea"
          v-model="inquiryDesc"
          placeholder="无"
          readonly
        ></el-input>
      </div>
      <div class="center_box" style="float: left; width: 31.5%">
        <div class="yy" style="width: 107px">发货港口：</div>
        <el-input
          v-model="sendShip"
          class="imm"
          placeholder="无"
          readonly
        ></el-input>
        <span class="cored">*</span>
      </div>
      <div class="center_box">
        <div class="yy" style="width: 150px">收货国家：</div>
        <el-input
          v-model="receiveCountry"
          class="imm"
          placeholder="无"
          readonly
        ></el-input>
        <span class="cored">*</span>
      </div>
      <div class="Image" style="clear: both; margin-top: 25px">
        <div class="jip">图片：</div>
        <div class="typeImage">
          <img
            :src="item"
            v-for="(item, index) in Oimage"
            class="bgc1"
            :key="index"
            alt=""
          />
          <label v-if="Oimage.length == 0" for="image">
            <div class="bgc">+</div>
          </label>
        </div>
      </div>
      <div class="dital">联系方式</div>
      <div class="center">
        <div class="center_box">
          <div class="yy" style="width: 120px">手机号：</div>
          <el-input
            v-model="contactPhone"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
          <span class="cored">*</span>
        </div>
        <div class="center_box">
          <div class="yy" style="width: 150px">联系人姓名：</div>
          <el-input
            v-model="contactName"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
          <span class="cored">*</span>
        </div>
        <div class="center_box">
          <div class="yy" style="width: 150px">公司名称：</div>
          <el-input
            v-model="companyName"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
          <span class="cored">*</span>
        </div>
      </div>
      <div class="center" v-if="isAppointFactory == 2">
        <div class="center_box">
          <div class="yy" style="width: 150px">工厂名称：</div>
          <el-input
            v-model="ccname"
            class="imm"
            placeholder="无"
            readonly
          ></el-input>
          <span class="cored">*</span>
        </div>
      </div>
      <div class="ooo">
        <div>
          是否发送到抢单大厅:
          <el-radio-group v-model="isSendHall" disabled>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router' //引入路由
import MemberTitle from '../../../components/MemberTitle'
import { ref, getCurrentInstance, onMounted } from 'vue'
export default {
  components: {
    MemberTitle
  },
  setup () {
    const route = useRoute()
    const { proxy } = getCurrentInstance()
    const inquiryId = ref(route.query.inquiryId)
    const isAppointFactory = ref(route.query.isAppointFactory)
    const input = ref('') //报价截止时间
    const deadlineTime = ref('') //交货时间
    const inquiryGoodsName = ref('') //品名
    const inquirySpec = ref('') //规格
    const targetPrice = ref('') //单位目标价
    const purchaseNumber = ref('') //采购量
    const inquiryDesc = ref('') //描述
    const sendShip = ref('') //发货港口
    const receiveCountry = ref('') //收货国家
    const Oimage = ref([]) //图片
    const contactPhone = ref('') //手机号
    const contactName = ref('') //联系人姓名
    const companyName = ref('') //公司名称
    const ccname = ref(route.query.name) //工厂名称
    const isSendHall = ref('') //是否发送到抢单大厅
    // const L = proxy.$getCurLanguage();

    const info = () => {
      proxy
        .$get(
          '/v3/goods/front/goods/inquiry/detail?inquiryId=' + inquiryId.value
        )
        .then(res => {
          // console.log('询价信息------111', res)
          input.value = res.data.deliveryTime
          deadlineTime.value = res.data.deadlineTime
          inquiryGoodsName.value = res.data.inquiryGoodsName
          inquirySpec.value = res.data.inquirySpec
          targetPrice.value = res.data.targetPrice
          purchaseNumber.value = res.data.purchaseNumber
          inquiryDesc.value = res.data.inquiryDesc
          sendShip.value = res.data.portName
          receiveCountry.value = res.data.receiveCountry
          Oimage.value = res.data.goodsImageList
          contactPhone.value = res.data.contactPhone
          contactName.value = res.data.contactName
          companyName.value = res.data.companyName
          ccname.value = res.data.factoryName
          isSendHall.value = res.data.isSendHall
        })
    }

    onMounted(() => {
      info()
    })

    return {
      info,
      inquiryId,
      isAppointFactory,
      input,
      deadlineTime,
      inquiryGoodsName,
      inquirySpec,
      targetPrice,
      purchaseNumber,
      inquiryDesc,
      sendShip,
      receiveCountry,
      Oimage,
      contactPhone,
      contactName,
      companyName,
      ccname,
      isSendHall
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/fabuxuenjia.scss';
</style>
